module.exports = __webpack_public_path__ + "media/addons/Rush-fd1eee26.svg";